<div id="managePopUp">
  <div class="modal-header">
    <div class="modal-title">{{header | titlecase}}</div>
    <button type="button" class="close" aria-label="Close" (click)="onCloseClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class='row'>
      <div class='col-lg-6 col-md-6 col-sm-6 col-xs-12'>
        <div class='listing-content-label'>Account name</div>
      </div>
      <div class='col-lg-6 col-md-6 col-sm-6 col-xs-12'>
          <div class='label_box address_label_box'>
              <div class='question sec_name'>
                <input *ngIf="banName && banName !== '-' " #newBanName [ngModel]="banName" (keyup)="onKeyup(newBanName.value)"  type='text' class='name' required='' placeholder='Enter text here' maxlength='30'>
                <input *ngIf="banName === '-' || banName === '' " #newBanName  (keyup)="onKeyup(newBanName.value)"  type='text' class='name' required='' placeholder='Enter text here' maxlength='30'> 
 
              </div>
          </div>
      </div>
    </div>

    <div class='row'>
      <div class='col-md-12'>
        <div class='alert_box' *ngIf="banAPiFailureFlag">
          <div class='alert_txt'>
            <div class='info_outlne alert_icon'> </div>
            {{authoringContentData?.accountListingPage?.banFirendlyApiErrorMsg}}
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="modal-footer pb-5 pull-right">
    <button type="button" class="btn secondary_btn" (click)="onCancelClick()"> {{authoringContentData?.accountListingPage?.cancelBtnTxt}} </button>
    <button type="button" class="btn primary_btn " [disabled]="!confirmBtnFlag || isSubmitReadOnly" (click)="updateBanName()"> {{authoringContentData?.accountListingPage?.confirmBtnTxt}} </button>
  </div>
</div>
